import { render } from "./grupoetapa.vue?vue&type=template&id=6d886604&scoped=true"
import script from "./grupoetapa.vue?vue&type=script&lang=js"
export * from "./grupoetapa.vue?vue&type=script&lang=js"

import "./grupoetapa.vue?vue&type=style&index=0&id=6d886604&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d886604"]])

export default __exports__